import { LazyLoader } from "@NextSkyTheme/lazy-load";

let productScrollGradientCleanup;

function initProductScrollGradient() {
  if (productScrollGradientCleanup) productScrollGradientCleanup();

  const productSection = document.querySelector("[data-product-scroll-gradient]");
  if (!productSection) return;

  const gradient = productSection.querySelector(".product-scroll-gradient");
  const sectionWrapper = productSection.closest(".main-product-section") || productSection;
  const sectionSiblings = Array.from(sectionWrapper.parentElement.children);
  const productPageSections = sectionSiblings.slice(sectionSiblings.indexOf(sectionWrapper) + 1);
  const triggerSection = productPageSections[0];
  const gradientEndSection = productPageSections[productPageSections.length - 1];
  if (!gradient || !triggerSection || !gradientEndSection) return;

  let frame = null;

  function clamp(value) {
    return Math.min(Math.max(value, 0), 1);
  }

  function updateGradient() {
    frame = null;

    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const triggerRect = triggerSection.getBoundingClientRect();
    const gradientEndRect = gradientEndSection.getBoundingClientRect();
    const productRect = productSection.getBoundingClientRect();
    const triggerTop = triggerRect.top + scrollY + 20;
    const productBottom = productRect.bottom + scrollY;
    const gradientEndBottom = gradientEndRect.bottom + scrollY;
    const fadeStart = triggerTop - viewportHeight;
    const fadeEnd = triggerTop;
    const progress = fadeEnd === fadeStart ? 1 : clamp((scrollY - fadeStart) / (fadeEnd - fadeStart));
    const extension = Math.max(0, gradientEndBottom - productBottom);

    gradient.style.opacity = progress.toFixed(3);
    gradient.style.setProperty("--product-scroll-gradient-bottom", `-${extension}px`);
    gradient.classList.toggle("is-active", extension > 0);
  }

  function requestUpdate() {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(updateGradient);
  }

  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate);
  requestUpdate();

  productScrollGradientCleanup = function () {
    window.removeEventListener("scroll", requestUpdate);
    window.removeEventListener("resize", requestUpdate);
    if (frame !== null) window.cancelAnimationFrame(frame);
    productScrollGradientCleanup = null;
  };
}

initProductScrollGradient();
document.addEventListener("shopify:section:load", initProductScrollGradient);

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];
    const currentProductID = productJson.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    const productJson = JSON.parse(prodData.innerHTML);
    const storedProducts = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          new LazyLoader(".image-lazy-load");
        })
        .finally(() => {})
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    this.main = document.querySelector(".main-product-section");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".block-product__buttons");
    const footer = document.querySelector("footer");
    if (!primaryBtn) return;
    var isVisible = true;
    window.addEventListener("scroll", function () {
      const buttonRect = primaryBtn.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          _this.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
          isVisible = true;
        } else {
          if (
            !isVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            isVisible = true;
            _this.classList.remove("show-sticky-cart");
            document.documentElement.classList.remove(
              "show-sticky-cart-active"
            );
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
            document.documentElement.classList.add("show-sticky-cart-active");
          }
        }
      } else {
        if (
          !isVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          isVisible = true;
          _this.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
        } else if (isVisible && buttonRect.bottom <= 0) {
          isVisible = false;
          _this.classList.add("show-sticky-cart");
          document.documentElement.classList.add("show-sticky-cart-active");
        }
      }
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);

const infoGallerySlide = () => {
  const gallery = document.querySelectorAll(".info-gallery__card");
  gallery.forEach((e) => {
    e.addEventListener("mouseover", (event) => {
      const currentTarget = event.currentTarget;
      if (!currentTarget.classList.contains("active")) {
        gallery.forEach((el) => {
          el.classList.remove("active");
        });
        currentTarget.classList.add("active");
      }
    });
  });
};
document.addEventListener("shopify:section:load", function () {
  infoGallerySlide();
});
infoGallerySlide();
